<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="false"
                        ></action-toolbar-buttons>
                        <div class="btn-group" *ngIf="canEdit">
                            <button type="button" class="btn btn-sm btn-secondary" (click)="deleteSelectedItem()" [disabled]="!grid.hasItemSelected">
                                <fa-icon class="d-none d-sm-inline-block" [icon]="faXmark"></fa-icon> Delete
                            </button>
                        </div>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Date'" [binding]="'date'" [width]="120" [format]="'MM/dd/yyyy'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Status'" [binding]="'status'" [width]="110"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'jobName'" [width]="'2*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Location'" [binding]="'jobSiteLocation'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Inspector'" [binding]="'inspectorName'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Open Issues'" [binding]="'nonCompliantOpenCount'" [width]="110" [align]="'center'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Total Non-Compliant'" [binding]="'nonCompliantCount'" [width]="160" [align]="'center'"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
